import { ThunkType } from "../../../../core/store/reducers";
import createOrderIndApi from "../api/createOrderInd";
import updateOrderIndApi from "../api/updateOrderInd";
import { OrderIndData } from "../types";
import { setFetchState, invalidateorderInd } from "../orderIndDataReducer";

export const upsertOrderInd = (orderInd: OrderIndData ): ThunkType => async ( dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user

  const result = orderInd.orderIndId
    ? await dispatch(updateOrderIndApi(userId, orderInd))
    : await dispatch(createOrderIndApi(userId, orderInd))

  if (result &&  result.resCode === "OK") {
    dispatch(setFetchState({ type: "successful", result: result.resDesc }));
    dispatch(invalidateorderInd());
    return result.resDesc;
  } else {
    dispatch(setFetchState({ type: "error", errorCode: result?.resCode }));
  }
};
